export default __webpack_public_path__ + "static/bannerBgImg2-4e21c5bdf662e3be7b7bb40691411636.png";